// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-2d9c728c]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.scroll-news[data-v-2d9c728c] {\n  min-height: 100px;\n}\n.cont-box[data-v-2d9c728c] {\n  overflow: hidden;\n}\n.cont-box p[data-v-2d9c728c] {\n  height: 30px;\n  line-height: 30px;\n}", ""]);
// Exports
module.exports = exports;
